"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExistingRid = void 0;
/**
 * Get existing rid from event
 * @param event event
 * @return {string} rid if found in event in any of the headers/query parameters, etc. undefined if not
 */
const getExistingRid = (event) => {
    var _a, _b, _c, _d;
    if (!event) {
        return undefined;
    }
    return ((_a = event.headers) === null || _a === void 0 ? void 0 : _a["x-ssky-rid"]) ||
        ((_b = event.queryStringParameters) === null || _b === void 0 ? void 0 : _b["_rid"]) ||
        ((_c = event.queryStringParameters) === null || _c === void 0 ? void 0 : _c["rid"]) ||
        ((_d = event.requestContext) === null || _d === void 0 ? void 0 : _d["requestId"]) ||
        event.transactionId;
};
exports.getExistingRid = getExistingRid;
//# sourceMappingURL=ridUtils.js.map